<template lang="pug">
  v-dialog(v-model='state.dialog' width='800')
    template(v-slot:activator='{ on }')
      v-btn(color='primary' v-on='on')
        v-icon fas fa-plus fa-2x
    v-card
      v-form(autocomplete=false v-model='valid')
        v-toolbar(dark color='primary')
            h2 Registro de Partida Contable
            v-spacer
            v-btn(icon dark @click='cerrar()')
                v-icon fas fa-times
        v-container(grid-list-md)
            v-row.pa-2
                v-col.xs6.pa-1
                    v-text-field(:rules='[rules.required]' type='number' label='Código' v-model='partidas.codigo' :disabled='(state.selectedKey=="") ? false : true')
                v-col.xs6.pa-1
                    v-text-field(:rules='[rules.required]' label='Descripción' v-model='partidas.descripcion')
            v-row.pa-2
                v-col.xs4.pa-1
                    v-switch(label='Mostrar saldo en cartas' v-model='partidas.cartas')
                v-col.xs4.pa-1
                    v-switch(label='Mostrar saldo en histograma' v-model='partidas.histograma')
                v-col.xs4.pa-1
                    v-switch(label='Mostrar saldo acumulado en carta' v-model='partidas.acumulado')
            v-spacer
            v-row.pa-2
                v-col.xs5.pa-1
                v-spacer
                    v-btn(color='primary' @click='(valid) ? add() : null' v-html='state.selectedKey=="" ? "Guardar" : "Actualizar"' :disabled='(valid) ? false : true')  

</template>
<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import { getPeriod } from '@/Helper.js'
export default {
    data: ()=>({
        valid: true
    }),
    methods: {
        ...mapActions({
            add: 'Partidas_Contables/add',
            clean: 'Partidas_Contables/clean',
            get: 'Partidas_Contables/get',
            cerrar: 'Partidas_Contables/cleanForm'
        }),    
    },
    computed: {
        ...mapState({
            rules: state=>state.Helpers.rules,
            partidas: state=>state.Partidas_Contables.partidas,
            state: state=>state.Partidas_Contables
        })
    }
}
</script>

